// src/components/GuestWelcomeModal.js
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { buttons, rounded, fontSizes } from "../styles/tokens";

function ModalContent({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    // prevent background scroll
    const orig = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = orig;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      aria-modal="true"
      role="dialog"
      aria-labelledby="guest-welcome-title"
      className="fixed inset-0 z-[99999] flex items-center justify-center"
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div
        className="relative mx-4 w-full max-w-md bg-white shadow-2xl p-6 text-left border"
        style={{ borderRadius: "1rem" }}
      >
        <h2 id="guest-welcome-title" className="font-semibold text-xl mb-3">
          Welcome to Loopy
        </h2>
        <div className={`${fontSizes.base} text-gray-800 space-y-3`}>
          <p>
            Although you can load videos and create loops as an anonymous guest,
            you need to be logged in for slicing and saving features.
          </p>
          <p>
            Please either login using Google authentication or create an account
            using your email address.
          </p>
        </div>

        <div className="mt-5 flex justify-end">
          <button onClick={onClose} className={`${buttons.activePurple} ${rounded.md}`}>
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}

export default function GuestWelcomeModal({ open, onClose }) {
  // Render in a portal to avoid any parent stacking-context issues
  return ReactDOM.createPortal(
    <ModalContent open={open} onClose={onClose} />,
    document.body
  );
}
